import type { ChannelId, TeamId } from '@cyphex/types/common';

/**
 * `directory(null)` is the whole-workspace read the shell does once at start;
 * `directory(teamId)` is the narrower read a team page can use. They are
 * separate keys on purpose — occupancy events invalidate/patch both, and a
 * shared key would make the narrow read evict the wide one.
 */
export const VOICE_KEYS = {
  all: ['voice'] as const,
  directory: (teamId: TeamId | null) => [...VOICE_KEYS.all, 'directory', teamId ?? 'all'] as const,
  occupants: (channelId: ChannelId) => [...VOICE_KEYS.all, 'occupants', channelId] as const,
} as const;
